"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IAirwebTicketLegacyRenewalInterval = exports.TRANSFER = exports.CARD = exports.IAirwebTicketLegacyProductPivotType = void 0;
var IAirwebTicketLegacyProductPivotType;
(function (IAirwebTicketLegacyProductPivotType) {
    IAirwebTicketLegacyProductPivotType["DAY_PIVOT"] = "DAY_PIVOT";
    IAirwebTicketLegacyProductPivotType["WEEK_PIVOT"] = "WEEK_PIVOT";
    IAirwebTicketLegacyProductPivotType["MONTH_PIVOT"] = "MONTH_PIVOT";
})(IAirwebTicketLegacyProductPivotType = exports.IAirwebTicketLegacyProductPivotType || (exports.IAirwebTicketLegacyProductPivotType = {}));
exports.CARD = 'CARD';
exports.TRANSFER = 'TRANSFER';
var IAirwebTicketLegacyRenewalInterval;
(function (IAirwebTicketLegacyRenewalInterval) {
    IAirwebTicketLegacyRenewalInterval["EVERY_WEEK"] = "P7D";
    IAirwebTicketLegacyRenewalInterval["EVERY_TWO_WEEK"] = "P14D";
    IAirwebTicketLegacyRenewalInterval["EVERY_MONTH"] = "P1M";
    IAirwebTicketLegacyRenewalInterval["EVERY_SIX_MONTH"] = "P6M";
    IAirwebTicketLegacyRenewalInterval["EVERY_YEAR"] = "P1Y";
})(IAirwebTicketLegacyRenewalInterval = exports.IAirwebTicketLegacyRenewalInterval || (exports.IAirwebTicketLegacyRenewalInterval = {}));
//# sourceMappingURL=product.interface.js.map